import { Controller } from "react-hook-form"

export default ({control, without = []}) => {
  return (<fieldset className="fieldset bg-base-200 border-base-300 rounded-box border p-4 w-full">
  <legend className='text-base'>Adresse</legend>

  <Controller 
    name="adresse_ligne1" 
    control={control}
    defaultValue=""
    render={({field}) => (
      <label className="input w-full">
        <input 
          type="text" 
          placeholder="Adresse ligne 1"
          {...field}
          value={field.value || ''} 
        />
      </label>
    )}
  />

  <Controller 
    name="adresse_ligne2" 
    control={control}
    defaultValue=""
    render={({field}) => (
      <label className="input w-full">
        <input 
          type="text" 
          {...field}
          placeholder="Adresse ligne 2"
          value={field.value || ''} 
        />
      </label>
    )}
  />

  <Controller 
    name="adresse_ligne3" 
    control={control}
    defaultValue=""
    render={({field}) => (
      <label className="input w-full">
        <input 
          type="text" 
          placeholder="Adresse ligne 3"
          {...field}
          value={field.value || ''} 
        />
      </label>
    )}
  />

  <div className="flex gap-2">
    <Controller 
      name="code_postal" 
      control={control}
      defaultValue=""
      render={({field}) => (
        <label className="input w-1/4">
          <input 
            type="text" 
            {...field}
            placeholder="Code Postal" 
            value={field.value || ''} 
          />
        </label>
      )}
    />

    <Controller 
      name="ville" 
      control={control}
      defaultValue=""
      render={({field}) => (
        <label className="input w-3/4">
          <input 
            type="text" 
            placeholder="Ville" 
            {...field}
            value={field.value || ''} 
          />
        </label>
      )}
    />
  </div>

  {!without.includes('pays') && (
    <Controller 
      name="country" 
      control={control}
      defaultValue=""
      render={({field}) => (
        <label className="input w-2/3">
          <span className="label">Pays</span>
          <input 
            type="text" 
            {...field}
            value={field.value || ''} 
          />
        </label>
      )}
    />
  )}
</fieldset>)
}